import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Header2 from "../../components/header/Header2";
import Scrollbar from "../../components/WhatsAppBtn/WhatsAppBtn";
import Footer from "../../components/footer/Footer";
import Bg from "../../images/bg/page_bg01.jpg";
import CtaSection from "../../components/CtaSection/CtaSection";
import icon from "../../images/icon/magic.svg";

const PrivacyPage = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };
  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <Header2 />
        <section
          className="page-title cp-page-title pt-200 pos-rel bg_img"
          style={{ backgroundImage: `url(${Bg})` }}
        >
          <div className="container">
            <div className="page-title-wrap">
              <div className="row mt-none-30 align-items-center">
                <div className="col-lg-8 mt-30">
                  <div className="page-title-box">
                    <span className="sub-title">
                      <img src={icon} alt="" />
                      Política de Privacidade
                    </span>
                    <h2 className="title">
                      Política de Privacidade <br /> Somar Cloud - Seus dados{" "}
                      <br /> protegidos e seguros
                    </h2>
                    <span className="page-update_time">
                      Atualizado em : 6 de julho de 2025
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="terms&conditions-section cp-det-bg">
          <div className="container">
            <div className="terms-section_inner pt-120 pb-75">
              <div className="row">
                <div className="col-lg-11">
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Controlador de dados e coleta de informações
                    </h2>
                    <p>
                      A Somar Cloud está comprometida com a proteção de sua
                      privacidade e atua como controladora de dados pessoais
                      conforme a Lei Geral de Proteção de Dados (LGPD - Lei
                      13.709/18). Os tipos de dados pessoais coletados podem
                      variar dependendo dos serviços oferecidos e podem ser
                      fornecidos voluntariamente pelos usuários ou coletados
                      automaticamente ao usar este site. Estes dados podem
                      incluir, mas não se limitam a: informações fornecidas pelo
                      usuário, cookies e outras ferramentas de rastreamento.
                    </p>
                    <p>
                      Cookies são utilizados exclusivamente para melhorar a
                      experiência do usuário e personalizar as ofertas de
                      serviços. Determinados tipos de dados podem ser
                      necessários para acessar e utilizar recursos específicos
                      ou serviços neste website. Por exemplo, informações de
                      contato, detalhes da conta ou preferências podem ser
                      necessárias para personalizar a experiência ou habilitar
                      funcionalidades específicas.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Responsabilidades do usuário
                    </h2>
                    <p>
                      Os usuários são responsáveis por quaisquer dados de
                      terceiros compartilhados através do website da Somar Cloud
                      e afirmam ter os direitos necessários para comunicar tais
                      dados, isentando assim a Somar Cloud de qualquer
                      responsabilidade associada. Ao fornecer dados pessoais de
                      terceiros, o usuário declara ter obtido o consentimento
                      adequado conforme exigido pela LGPD.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Processamento e segurança de dados
                    </h2>
                    <p>
                      Os dados são processados usando sistemas de TI seguros nos
                      escritórios operacionais da Somar Cloud e em outros locais
                      necessários para apoiar nossos serviços, sempre dentro do
                      território brasileiro ou com adequado nível de proteção
                      conforme a LGPD. A Somar Cloud garante medidas rigorosas
                      de segurança para prevenir acesso não autorizado,
                      modificação ou destruição de dados pessoais.
                    </p>
                    <p>
                      Em alguns casos, dados podem ser acessados por membros
                      selecionados da equipe (ex: vendas, marketing,
                      administração de sistemas) ou terceiros externos (ex:
                      prestadores de serviços), conforme autorizado pela Somar
                      Cloud e mediante contratos de confidencialidade. Todas as
                      transferências de dados seguem os princípios da LGPD e são
                      realizadas com base em uma das hipóteses legais previstas
                      na lei.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Armazenamento e retenção de dados
                    </h2>
                    <p>
                      Dados pessoais são mantidos apenas pelo tempo necessário
                      para cumprir a finalidade pretendida ou conforme exigido
                      por lei. O período de retenção varia de acordo com a
                      finalidade do tratamento e as obrigações legais
                      aplicáveis. Os usuários podem solicitar a exclusão ou
                      suspensão de dados a qualquer momento entrando em contato
                      com a Somar Cloud através dos canais oficiais.
                    </p>
                    <p>
                      Após o término do período de retenção, os dados são
                      eliminados de forma segura, garantindo que não possam ser
                      recuperados ou utilizados indevidamente.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Compartilhamento de dados e ordem legal
                    </h2>
                    <p>
                      A Somar Cloud pode divulgar dados pessoais para cumprir
                      obrigações legais ou responder a solicitações de
                      autoridades públicas, sempre em conformidade com a
                      legislação brasileira. Dados pessoais também podem ser
                      utilizados em processos legais decorrentes do uso
                      inadequado do website ou serviços.
                    </p>
                    <p>
                      Não compartilhamos dados pessoais com terceiros para fins
                      comerciais sem o consentimento explícito do titular dos
                      dados, exceto nas hipóteses previstas na LGPD.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Direitos do titular dos dados
                    </h2>
                    <p>
                      Em conformidade com a LGPD, os usuários possuem os
                      seguintes direitos em relação aos seus dados pessoais:
                    </p>
                    <ul className="privacy-details">
                      <li>
                        Confirmação da existência de tratamento de dados
                        pessoais;
                      </li>
                      <li>
                        Acesso aos dados pessoais e informações sobre o
                        tratamento;
                      </li>
                      <li>
                        Correção de dados incompletos, inexatos ou
                        desatualizados;
                      </li>
                      <li>
                        Anonimização, bloqueio ou eliminação de dados
                        desnecessários;
                      </li>
                      <li>
                        Portabilidade dos dados a outro fornecedor de serviços;
                      </li>
                      <li>
                        Eliminação dos dados pessoais tratados com base no
                        consentimento;
                      </li>
                      <li>
                        Informação sobre as entidades públicas e privadas com as
                        quais compartilhamos dados;
                      </li>
                      <li>
                        Informação sobre a possibilidade de não fornecer
                        consentimento e sobre as consequências da negativa;
                      </li>
                      <li>Revogação do consentimento a qualquer momento;</li>
                      <li>
                        Revisão de decisões automatizadas que afetem seus
                        interesses;
                      </li>
                      <li>
                        Apresentação de reclamação à Autoridade Nacional de
                        Proteção de Dados (ANPD).
                      </li>
                    </ul>
                    <p>
                      Para exercer seus direitos, entre em contato conosco
                      através dos canais oficiais disponíveis nesta página.
                      Responderemos às solicitações em até 15 dias, conforme
                      previsto na LGPD.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Cookies e tecnologias similares
                    </h2>
                    <p>
                      A Somar Cloud utiliza cookies e tecnologias similares para
                      melhorar a experiência do usuário, personalizar conteúdo e
                      analisar o uso do website. Os cookies são pequenos
                      arquivos de texto armazenados no dispositivo do usuário
                      que nos permitem reconhecer visitas futuras e
                      preferências.
                    </p>
                    <p>
                      Utilizamos cookies essenciais (necessários para o
                      funcionamento do site), cookies de desempenho (para
                      análises e melhorias) e cookies de funcionalidade (para
                      personalização). Você pode gerenciar suas preferências de
                      cookies através das configurações do seu navegador.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Atualizações da política
                    </h2>
                    <p>
                      A Somar Cloud pode atualizar esta Política de Privacidade
                      periodicamente para refletir mudanças em nossas práticas,
                      na legislação aplicável ou em nossos serviços.
                      Recomendamos que os usuários revisem esta página
                      regularmente para estar cientes de quaisquer alterações.
                    </p>
                    <p>
                      Quando realizarmos alterações substanciais, notificaremos
                      os usuários através de e-mail ou aviso em nosso website. O
                      uso continuado do website após as alterações constitui
                      aceitação dos novos termos.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Segurança da informação
                    </h2>
                    <p>
                      A Somar Cloud implementa medidas técnicas e
                      organizacionais adequadas para proteger dados pessoais
                      contra acesso não autorizado, alteração, divulgação ou
                      destruição. Utilizamos criptografia, controles de acesso,
                      monitoramento contínuo e outras práticas de segurança
                      alinhadas com as melhores práticas do mercado.
                    </p>
                    <p>
                      Embora adotemos medidas rigorosas de segurança, é
                      importante reconhecer que nenhum método de transmissão ou
                      armazenamento é 100% seguro. Por isso, incentivamos os
                      usuários a também adotarem práticas seguras ao usar nossos
                      serviços.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Transferência internacional de dados
                    </h2>
                    <p>
                      Quando necessário para a prestação de nossos serviços,
                      dados pessoais podem ser transferidos para países que
                      oferecem grau de proteção adequado, conforme reconhecido
                      pela ANPD, ou mediante garantias específicas de proteção,
                      como cláusulas contratuais padrão.
                    </p>
                    <p>
                      Todas as transferências internacionais são realizadas em
                      conformidade com a LGPD e com a devida proteção dos
                      direitos dos titulares dos dados.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Contato e Encarregado de Dados
                    </h2>
                    <p>
                      Para exercer seus direitos, esclarecer dúvidas sobre esta
                      Política de Privacidade ou reportar preocupações sobre o
                      tratamento de dados pessoais, entre em contato conosco:
                    </p>
                    <p>
                      <strong>Encarregado de Dados (DPO):</strong>
                    </p>
                    <p>
                      E-mail:{" "}
                      <a href="mailto:dpo@somarcloud.com.br">
                        contato@somar.cloud
                      </a>
                    </p>
                    <p>Telefone: (11) 3090-1260</p>
                    <p>Endereço: Av. Paulista, 1106, Sala 01, Andar 16</p>
                    <p>
                      <Link
                        onClick={ClickHandler}
                        to="/contact"
                        className="details-link"
                      >
                        Clique aqui
                      </Link>{" "}
                      para acessar nossa página de contato ou envie-nos um
                      e-mail para:{" "}
                      <a href="mailto:contato@somarcloud.com.br">
                        contato@somar.cloud
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <CtaSection cClass={"bg"} />
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default PrivacyPage;
